import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../images/ic_windows-fill.png'
import _imports_1 from '../../images/wechartQrCode.png'
import _imports_2 from '../../images/ic_phone.png'


const _withScopeId = n => (_pushScopeId("data-v-81bd3e44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "download-btn absolute" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "marginRight4"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("iframe", {
  name: "downloadErp",
  style: {"display":"none"}
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "marginRight4"
}, null, -1))
const _hoisted_7 = { class: "home-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_BannerView = _resolveComponent("BannerView")!
  const _component_CoreFunc = _resolveComponent("CoreFunc")!
  const _component_FivePoint = _resolveComponent("FivePoint")!
  const _component_PlayWell = _resolveComponent("PlayWell")!
  const _component_CompareErp = _resolveComponent("CompareErp")!
  const _component_BluePrint = _resolveComponent("BluePrint")!
  const _component_Cooperate = _resolveComponent("Cooperate")!
  const _component_HotLine = _resolveComponent("HotLine")!
  const _component_FooterView = _resolveComponent("FooterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BannerView, { imgBg: _ctx.imgBg }, {
      extraOpt: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_button, {
            class: "inline-flex flex-center orange",
            onClick: _ctx.downloadErp
          }, {
            icon: _withCtx(() => [
              _hoisted_3
            ]),
            default: _withCtx(() => [
              _createTextVNode(" Windows版下载 ")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _hoisted_4,
          _createVNode(_component_a_tooltip, {
            placement: "bottom",
            color: "#fff",
            overlayClassName: "download-tooltip"
          }, {
            title: _withCtx(() => [
              _hoisted_5
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                class: "inline-flex flex-center"
              }, {
                icon: _withCtx(() => [
                  _hoisted_6
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" 微信小程序 ")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["imgBg"]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_CoreFunc),
      _createVNode(_component_FivePoint),
      _createVNode(_component_PlayWell),
      _createVNode(_component_CompareErp),
      _createVNode(_component_BluePrint),
      _createVNode(_component_Cooperate),
      _createVNode(_component_HotLine)
    ]),
    _createVNode(_component_FooterView)
  ]))
}